import { query } from './yUtil';
import { isTBS } from './UA'

export function getAppName() {
  let appName = 'qb'
  if (window.appName) {
    appName = window.appName;
  }

  // qqkd 和 qb_10 强制给 qb
  if (appName === 'qqkd' || appName === 'qb_10') {
    appName = 'qb';
  }

  return appName
}

/**
 * @desc 获取来源应用名称
 *
 * @export
 * @returns
 */
let sourceAppName = null
export function getSourceAppName() {
  if (sourceAppName) return sourceAppName

  sourceAppName = query('from_app') || 'qb'

  return sourceAppName
}

// 资讯图文
export function getArticleChannelRefer() {
  const userAgent = window.navigator.userAgent
  const fromApp = query('from_app')

  let data = {
    kbChannel: '9004847',
    kbRefer: 'liulanqi_share_h5',
    qbPosID: '816971',
    qbChannel: '11813'
  }

  if (!isTBS(userAgent)) {
    Object.assign(data, {
      kbChannel: '9005183',
      kbRefer: 'liulanqi_plt_nottbs_arth5'
    })
  }

  if (fromApp === 'qb_10') {
    Object.assign(data, {
      kbChannel: '9003954',
      kbRefer: 'liulanqi_share_imagetext'
    })
  } else if (fromApp === 'kb') {
    Object.assign(data, {
      kbChannel: '9005184',
      kbRefer: 'kandian_plt_tbs_arth5'
    })
    if (!isTBS(userAgent)) {
      Object.assign(data, {
        kbChannel: '9005185',
        kbRefer: 'kandian_plt_nottbs_arth5'
      })
    }
  } else if (fromApp === 'qqkd') {
    Object.assign(data, {
      kbChannel: '9005186',
      kbRefer: 'qqkandian_plt_tbs_arth5'
    })
    if (!isTBS(userAgent)) {
      Object.assign(data, {
        kbChannel: '9005187',
        kbRefer: 'qqkandian_plt_nottbs_arth5'
      })
    }
  }

  return data
}

// 短视频
export function getNormalVideoChannelRefer() {
  const userAgent = window.navigator.userAgent
  const fromApp = query('from_app')

  let data = {
    kbChannel: '9005620',
    kbRefer: 'liulanqi_plt_tbs_videoh5',
    qbPosID: '816972',
    qbChannel: '11815'
  }

  if (!isTBS(userAgent)) {
    Object.assign(data, {
      kbChannel: '9005621',
      kbRefer: 'liulanqi_plt_nottbs_videoh5',
      qbPosID: '816973',
      qbChannel: '11817'
    })
  }

  if (fromApp === 'qb_10') {
    Object.assign(data, {
      kbChannel: '9005632',
      kbRefer: 'kandian_plt_tbs_agg_videoh5'
    })
    if (!isTBS(userAgent)) {
      Object.assign(data, {
        kbChannel: '9005633',
        kbRefer: 'kandian_plt_nottbs_agg_videoh5'
      })
    }
  } else if (fromApp === 'kb') {
    Object.assign(data, {
      kbChannel: '9005624',
      kbRefer: 'kandian_plt_tbs_videoh5'
    })
    if (!isTBS(userAgent)) {
      Object.assign(data, {
        kbChannel: '9005625',
        kbRefer: 'kandian_plt_nottbs_videoh5'
      })
    }
  } else if (fromApp === 'qqkd') {
    Object.assign(data, {
      kbChannel: '9005628',
      kbRefer: 'qqkandian_plt_tbs_videoh5'
    })
    if (!isTBS(userAgent)) {
      Object.assign(data, {
        kbChannel: '9005629',
        kbRefer: 'qqkandian_plt_nottbs_videoh5'
      })
    }
  }

  return data
}


// 小视频
export function getSmallVideoChannelRefer() {
  const userAgent = window.navigator.userAgent
  const fromApp = query('from_app')

  let data = {
    kbChannel: '9005622',
    kbRefer: 'liulanqi_plt_tbs_svideoh5'
  }

  if (!isTBS(userAgent)) {
    Object.assign(data, {
      kbChannel: '9005623',
      kbRefer: 'liulanqi_plt_nottbs_svideoh5'
    })
  }

  if (fromApp === 'qb_10') {
    Object.assign(data, {
      kbChannel: '9005634',
      kbRefer: 'qqkandian_plt_tbs_agg_videoh5'
    })
    if (!isTBS(userAgent)) {
      Object.assign(data, {
        kbChannel: '9005635',
        kbRefer: 'qqkandian_plt_nottbs_agg_videoh5'
      })
    }
  } else if (fromApp === 'kb') {
    Object.assign(data, {
      kbChannel: '9005626',
      kbRefer: 'kandian_plt_tbs_svideoh5'
    })
    if (!isTBS(userAgent)) {
      Object.assign(data, {
        kbChannel: '9005627',
        kbRefer: 'kandian_plt_nottbs_svideoh5'
      })
    }
  } else if (fromApp === 'qqkd') {
    Object.assign(data, {
      kbChannel: '9005630',
      kbRefer: 'qqkandian_plt_tbs_svideoh5'
    })
    if (!isTBS(userAgent)) {
      Object.assign(data, {
        kbChannel: '9005631',
        kbRefer: 'qqkandian_plt_nottbs_svideoh5'
      })
    }
  }

  return data
}

// 获取图文back页refer
function getBackNewsChannelRefer() {
  let data = {
    kbChannel: '9005903',
    kbRefer: 'liulanqi_plt_back_h5'
  }

  const mediaType = query('mediaType')

  if (mediaType === 'video') {
    data = {
      kbChannel: '9005904',
      kbRefer: 'liulanqi_plt_back_video'
    }
  }
  return data
}

// 获取短内容refer
function getShortContentChannelRefer() {
  const userAgent = window.navigator.userAgent

  // 默认快报
  let data = {
    kbChannel: '1100108550',
    kbRefer: 'liulanqi_plt_tbs_short_arth5',
    qbPosID: '816974',
    qbChannel: '1100110679'
  }

  if (!isTBS(userAgent)) {
    Object.assign(data, {
      kbChannel: '1100108551',
      kbRefer: 'liulanqi_plt_nottbs_short_arth5',
      qbPosID: '816975',
      qbChannel: '1100110678'
    })
  }

  return data
}

// 渠道号与refer
export function getChannelRefer() {
  if (window.location.pathname.includes('/video/')) {
    // 视频
    if (Number(query('classify')) === 1) {
      return getSmallVideoChannelRefer()
    }
    return getNormalVideoChannelRefer()
  } else if (window.location.pathname.includes('/backNews')) {
    // 图文back页面
    return getBackNewsChannelRefer()
  } else if (window.location.pathname.includes('/shortContent')) {
    // 短内容
    return getShortContentChannelRefer()
  } else {
    // 资讯正文
    return getArticleChannelRefer()
  }
}
